import React, {useState, useEffect, Fragment} from 'react'
import {useDispatch, useSelector} from 'react-redux';
import * as FeedfilterActions from '../../actions/FeedfilterActions'
import { Icon, Dropdown } from 'semantic-ui-react'
import {Rule, Marker} from './'


export function Conjunction(props){
    const dispatch = useDispatch();

    let marker = (props.type === 'and')?'&':(props.type === 'or')?'||':(props.type === 'scope')?'&':'!';
	let path = props.path || [];

    return (
        <li style={{
            padding: '5px 0px'	
        }}>
            <div>
            {
                props.marker?
                    <Marker marker={props.marker} />
                :null
            }
            {
                (props.type === 'and')?
                    'Alle der folgenden Bedingungen müssen erfüllt sein'
                :(props.type === 'or')?
                    'Eine der folgenden Bedingungen muss erfüllt sein'
                :(props.type === 'scope')?
                    'Ein Tipp muss alle der folgenden Bedingungen erfüllen'
                :'Keine der folgenden Bedinungen darf erfüllt sein'
            }
            
            <Dropdown style={{marginLeft: '20px'}} item text='Regel hinzufügen'>
                <Dropdown.Menu>
                <Dropdown.Item onClick={() => dispatch(FeedfilterActions.add_rule(path, props.scope))}> Bedingung</Dropdown.Item>
                <Dropdown.Item onClick={() => dispatch(FeedfilterActions.add_conjunction(path, 'and', props.scope))}>Mehrere Bedingungen, von denen <strong>ALLE</strong> erfüllt werden müssen</Dropdown.Item>
                <Dropdown.Item onClick={() => dispatch(FeedfilterActions.add_conjunction(path, 'or', props.scope))}>Mehrere Bedingungen, von denen <strong>EINE</strong> erfüllt werden muss</Dropdown.Item>
                <Dropdown.Item onClick={() => dispatch(FeedfilterActions.add_conjunction(path, 'not', props.scope))}>Mehrere Bedingungen, von denen <strong>KEINE</strong> erfüllt werden darf</Dropdown.Item>
                {
                    (props.scope !== 'outcomes')?
                        <Dropdown.Item onClick={() => dispatch(FeedfilterActions.add_conjunction(path, 'scope', 'outcomes'))}>Bedingungen für einzelne Tipps hinzufügen</Dropdown.Item>
                    :null
                }
                </Dropdown.Menu>
            </Dropdown>
            {
                (props.path)?
                <a onClick={(e) => dispatch(FeedfilterActions.remove_node(props.path))} style={{
                        color: '#FF0000',
                        marginLeft: '20px',
                        display: 'inline-block'
                    }}><Icon name="remove" /></a>
                :null
            }
            
            </div>
            <ul style={{
                listStyleType: 'none'	
            }}>
                {
                    (typeof props.conditions !== 'undefined' && props.conditions !== null)
                    ?props.conditions.map((condition, index) => {
                        let childPath = path.slice(0);
                        childPath.push('children');
                        childPath.push(index)
                        switch(condition.operation){
                            case 'rule':
                                return (
                                    <Rule key={index} path={childPath} marker={index === 0?'•':marker} scope={props.scope} condition={condition} />
                                )
                            case 'or':
                                return (
                                    <Conjunction key={index} path={childPath} marker={index === 0?'•':marker} scope={props.scope} type='or' conditions={condition.children} />
                                )
                            case 'and':
                                return (
                                    <Conjunction key={index} path={childPath} marker={index === 0?'•':marker} scope={props.scope} type='and' conditions={condition.children} />
                                )
                            case 'not':
                                return (
                                    <Conjunction key={index} path={childPath} marker={index === 0?'•':marker} scope={props.scope} type='not' conditions={condition.children} />
                                )
                            case 'scope':
                                return (
                                    <Conjunction key={index} path={childPath} marker={index === 0?'•':marker} scope='outcomes' type='scope' conditions={condition.children} />
                                )
                        }
                    })
                    :null
                }
            </ul>
        </li>
    )
}
		
		